/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import classNames from 'classnames';
import type { HelpLinkProps } from './types';

export function HelpLink({
  query,
  children,
  className,
  class: legacyClassName,
  ariaLabel,
  'aria-label': legacyAriaLabel,
  role,
  tabIndex,
}: HelpLinkProps) {
  return (
    <a
      className={classNames('HelpTopic', className, legacyClassName)}
      href="#"
      role={role}
      tabIndex={tabIndex}
      aria-label={legacyAriaLabel ?? ariaLabel}
      query={query}
      onClick={e => e.preventDefault()}
    >
      {children}
    </a>
  );
}

HelpLink.defaultProps = {
  className: '',
  ariaLabel: '',
  role: 'button',
  tabIndex: undefined,
};
